<template>
  <div>
    <div class="columns">
      <div class="column is-5">
        <div class="field">
          <label class="label">{{ $t("transaction number") }}</label>
          <div class="control">
            <input
              type="text"
              class="input"
              v-model="meta.transaction_unique_number"
              :placeholder="$t('transaction unique number')"
            />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("operation") }}</label>
          <div class="select">
            <select v-model="meta.maintenance_type">
              <option value="1">{{ $t("new user") }}</option>
              <option value="2">{{ $t("deactivation") }}</option>
              <option value="3">{{ $t("update") }}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("access type") }}</label>
          <div class="select">
            <select v-model="meta.access_type">
              <option value="1">{{ $t("analisys") }}</option>
              <option value="2">{{ $t("control") }}</option>
              <option value="3">{{ $t("managerial") }}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("username") }}</label>
          <div class="control">
            <input type="text" class="input" v-model="meta.new_username" />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("password") }}</label>
          <div class="control">
            <input type="text" class="input" v-model="meta.new_user_password" />
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("first name") }}</label>
          <div class="control">
            <input type="text" class="input" v-model="meta.first_name" />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("second name") }}</label>
          <div class="control">
            <input type="text" class="input" v-model="meta.second_name" />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("third name") }}</label>
          <div class="control">
            <input type="text" class="input" v-model="meta.third_name" />
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("first last name") }}</label>
          <div class="control">
            <input type="text" class="input" v-model="meta.first_last_name" />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("second last name") }}</label>
          <div class="control">
            <input type="text" class="input" v-model="meta.second_last_name" />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("married last name") }}</label>
          <div class="control">
            <input type="text" class="input" v-model="meta.married_last_name" />
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("email") }}</label>
          <div class="control">
            <input type="text" class="input" v-model="meta.email" />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("phone number") }}</label>
          <div class="control">
            <input type="text" class="input" v-model="meta.phone_number" />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("extension number") }}</label>
          <div class="control">
            <input type="text" class="input" v-model="meta.extension_number" />
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("job title") }}</label>
          <div class="control">
            <input type="text" class="input" v-model="meta.job_title" />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("location") }}</label>
          <div class="control">
            <input type="text" class="input" v-model="meta.location" />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("cui") }}</label>
          <div class="control">
            <input type="text" class="input" v-model="meta.cui" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Process_11",
  data() {
    return {
      meta: {
        correlative: "",
        query_reason_code: "",
        request_number: "",
        figure_code: "",
        person_code: "",
        periodicity: "",
        query_date: "",
        credit_asset_number: "",
      },
    };
  },
  methods: {
    get_data() {
      return this.meta;
    },
    set_data(data) {
      this.meta = data;
    },
  },
};
</script>

<style scoped>
/* Your component styles go here */
</style>
